import { MemberActionType } from './memberTypes';

export const setMemberPhone: (phone) => any = (phone) => async (dispatch) => {
  dispatch({
    type: MemberActionType.SET_MEMBER_PHONE,
    payload: phone,
  });
};

export const setMemberPoints: (points) => any =
  (points) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_MEMBER_POINTS,
      payload: points,
    });
  };

export const setMemberOtpVerified: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_MEMBER_OTP_VERIFIED,
      payload: boolVal,
    });
  };

export const setMemberLineBounded: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_IS_LINEID_BOUNDED,
      payload: boolVal,
    });
  };

export const setMemberDisagreeLineToBind: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_IS_DISAGREE_LINE_TO_BIND,
      payload: boolVal,
    });
  };

export const setMemberInfoRes: (data) => any = (data) => async (dispatch) => {
  dispatch({
    type: MemberActionType.SET_MEMBER_INFO_RES,
    payload: data,
  });
};

export const setStoreInfoRes: (data) => any = (data) => async (dispatch) => {
  dispatch({
    type: MemberActionType.SET_STORE_INFO_RES,
    payload: data,
  });
};

export const setMemberPageState: (state) => any =
  (state) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_MEMBER_PAGE_STATE,
      payload: state,
    });
  };

export const setMemberLangs: (data) => any = (data) => async (dispatch) => {
  dispatch({
    type: MemberActionType.SET_MEMBER_LANGS,
    payload: data,
  });
};

export const setShowMemberDropDown: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_SHOW_MEMBER_DROP_DOWN,
      payload: boolVal,
    });
  };

export const setMemberEditEntrance: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_MEMBER_EDIT_ENTRANCE,
      payload: boolVal,
    });
  };

export const setMemberRegisterEntrance: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_MEMBER_REGISTER_ENTRANCE,
      payload: boolVal,
    });
  };
export const setUpdateMemberPhone: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_UPDATE_MEMBER_PHONE,
      payload: boolVal,
    });
  };

export const setCurrentSelectedPhone: (data) => any =
  (data) => async (dispatch) => {
    dispatch({
      type: MemberActionType.SET_CURRENT_SELECTED_PHONE,
      payload: data,
    });
  };
